import "./PrivacyPolicy.css";
import { useEffect } from "react";
import Footer from "../../components/shared/Footer";
import MobileTopBar from "../../components/mobile/MobileTopBar";
import LegalContent from "../../components/shared/LegalContent";
import { privacyPolicy } from "../../Data/siteContent";
import useResponsive from "../../hooks/useResponsive";

const PrivacyPolicy = () => {
  const isMobile = useResponsive();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isMobile) {
    return (
      <div>
        <MobileTopBar />
        <div className="privacy-policy-content">
          <LegalContent data={privacyPolicy} />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <div className="privacy-policy-content">
        <LegalContent data={privacyPolicy} />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
